import { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import Icon, { IconPropsT } from './Icon';

const EmailUnreadIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        height="20"
        width="20"
        viewBox="0 0 20 20"
        fill={theme.colors.secondary.variant5}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m10 1 7.25 4.146q.354.208.552.542.198.333.198.75V15.5q0 .625-.438 1.062Q17.125 17 16.5 17h-13q-.625 0-1.062-.438Q2 16.125 2 15.5V6.438q0-.417.198-.75.198-.334.552-.542Zm0 9.229L16.5 6.5 10 2.771 3.5 6.5ZM10 12 3.5 8.292V15.5h13V8.292Zm0 3.5h6.5-13Z" />
      </svg>
    </Icon>
  );
};

export default EmailUnreadIcon;
